import { getNews, getNewsDetail } from '@services/external/translations.api';
import { call, put, takeLatest } from 'typed-redux-saga/macro';
import { newsActionTypes } from '../ducks/news';

function* getNewsRequest() {
  try {
    const req: any = yield* call(getNews);
    yield put({
      type: newsActionTypes.GET_NEWS_SUCCESS,
      payload: {
        listMeta: req.data.pagination,
        list: req.data.items,
      },
    });
  } catch {}
}

function* getDetailRequest({ payload }: any) {
  yield put({
    type: newsActionTypes.GET_DETAIL_SUCCESS,
    payload: null,
  });
  try {
    const req: any = yield* call(getNewsDetail, payload);
    yield put({
      type: newsActionTypes.GET_DETAIL_SUCCESS,
      payload: req.data,
    });
  } catch {}
}

function* newsSaga() {
  yield takeLatest(newsActionTypes.GET_NEWS_REQUEST, getNewsRequest);
  yield takeLatest(newsActionTypes.GET_DETAIL_REQUEST, getDetailRequest);
}

export default newsSaga;
